export default {
      id: "button-brunch-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#button-brunch",
      toString: function () {
        return this.url;
      }
    }